import { DetailCard } from "./DetailCard";
import { globalVariables } from "helper/globalVariables";
import { globalClasses } from "helper/globalClasses";
import { Location, Mail, Phone, User, UserSquare } from "helper/images";
import { chevronLeft } from "helper/icons";
import { TrailTitle } from "./TrailTitle";
import { TrailSubDetail } from "./TrailSubDetail";
import { TrailNotes } from "./TrailNotes";
import moment from "moment";
import { DEFAULT_DATE_FORMAT } from "helper/utility";
import PageInfo from "shared/Components/pageInfo";
import { orderSearchesElements } from "helper/orderSearchElements";

const { iconCls } = globalClasses;

const TrialDetail = ({ goBack, detail, smPadding = false }) => {
  // Contact details without phone number
  const contactDetails = [
    {
      icon: <UserSquare className={iconCls} />,
      value: detail?.host?.trialSecretaryName,
    },
    {
      icon: <Mail className={iconCls} />,
      value: detail?.host?.trialSecretaryEmail,
    },
  ];

  
  const ElementList = () => {
    return (
      <div className={`border rounded-lg shadow-100 p-6 my-3`}>
        <p className="font-bold text-gray-700 mt-2">Elements Offered:</p>
        <ul>
          {orderSearchesElements(detail?.search)?.map((search, index) => (
            <li key={index}>
              <i className="fas fa-check-circle text-green-500 mr-2"></i>
              - {search.searchName}
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <>
      <PageInfo title={globalVariables.trialDetail} onClick={goBack}/>
      <div className="md:hidden">
        <div
          className={`flex flex-col md:justify-center md:items-center`}
        >
          <div className="border border-gray-200  rounded-xl  bg-white  w-full p-6 mb-4 md:w-[50%]">
            <div>
              <p className="text-gray-900 text-xl font-semibold leading-[30px] font-sans">
                {moment.utc(detail?.trial?.trialDate).format(
                  "MMM DD, YYYY [–] dddd"
                )}
              </p>
              <p className="text-gray-900 text-xl font-semibold leading-[30px] font-sans">
                {detail?.trial?.trialName}
              </p>
              <p className="text-gray-900 text-xl font-semibold leading-[30px] font-sans">
                {detail?.trial?.trialLocationName}
              </p>
              <p className="text-gray-900 text-xl font-semibold leading-[30px] font-sans">
                {detail?.trial?.trialLocationAddress}
              </p>
              <p className="text-gray-900 text-xl font-semibold leading-[30px] font-sans">
                {`${detail?.trial?.city}, ${detail?.trial?.state} ${detail?.trial?.zip || ''}`}
              </p>
            </div>
            <div>
              <TrailTitle
                host={detail?.host?.hostName}
              />
            </div>

            <div className="flex flex-col h-[375px] w-full gap-4 mt-4 pt-4  border-t-[1px] border-gray-300">
              <TrailSubDetail
                name={detail?.judgeName}
                time={moment.utc(detail?.trial?.trialDate).format("hh:mm a")}
                level={detail?.search}
                fees={10}
                dogName={"Per Dog"}
                openDate={moment.utc(detail?.trial?.openDate).format(
                  DEFAULT_DATE_FORMAT
                )}
                closeDate={moment.utc(detail?.trial?.closeDate).format(
                  DEFAULT_DATE_FORMAT
                )}
                premium={detail?.trial?.trialFile ? "Premium" : "Premium Available Soon"}
                trialFile={detail?.trial?.trialFile}
              />
            </div>
            <div className="mt-12 pt-4 border-t-[1px] border-gray-300">
              <TrailNotes notes={detail?.trial?.notes} />
            </div>
          </div>
          <div className="w-full h-full md:w-[50%] shadow-100">
            <ElementList />
            <DetailCard
              showSub={true}
              label={globalVariables.contactDetails}
              data={contactDetails}
              width="w-full"
            />
          </div>
        </div>
      </div>
      <div className={`hidden md:flex my-4 lg:my-6 gap-4`}>
        <div className="shadow-100 rounded-md bg-white p-4 lg:p-6 w-[65%]">
          <div>
            <p className="text-gray-900 text-xl font-semibold leading-[30px] font-sans">
              {moment.utc(detail?.trial?.trialDate).format("MMM DD, YYYY [–] dddd")}
            </p>
            <p className="text-gray-900 text-xl font-semibold leading-[30px] font-sans">
              {detail?.trial?.trialName}
            </p>
            <p className="text-gray-900 text-xl font-semibold leading-[30px] font-sans">
              {detail?.trial?.trialLocationName}
            </p>
            <p className="text-gray-900 text-xl font-semibold leading-[30px] font-sans">
              {detail?.trial?.trialLocationAddress}
            </p>
            <p className="text-gray-900 text-xl font-semibold leading-[30px] font-sans">
              {`${detail?.trial?.city}, ${detail?.trial?.state} ${detail?.trial?.zip || ''}`}
            </p>
          </div>
          <TrailTitle host={detail?.host?.hostName} level={detail?.search} />

          <div className="py-4 gap-2 flex justify-between overflow-hidden">
            <div className="flex flex-col gap-3 w-[50%] lg:w-[40%]">
              <TrailSubDetail
                name={detail?.judgeName}
                time={moment.utc(detail?.trial?.trialDate).format("hh:mm a")}
                level={detail?.search}
                fees={10}
                dogName={"Per Dog"}
                openDate={moment.utc(detail?.trial?.openDate).format(
                  DEFAULT_DATE_FORMAT
                )}
                closeDate={moment.utc(detail?.trial?.closeDate).format(
                  DEFAULT_DATE_FORMAT
                )}
                premium={detail?.trial?.trialFile ? "Premium" : "Premium Available Soon"}
                trialFile={detail?.trial?.trialFile}
              />
            </div>
          </div>
          <div className="mt-8 pt-4 border-t-[1px] border-gray-300">
            <TrailNotes notes={detail?.trial?.notes} />
          </div>
        </div>

        <div className="w-[35%]">
          <DetailCard
            showSub={true}
            label={globalVariables.contactDetails}
            data={contactDetails}
          />
          <ElementList />
        </div>
      </div>
    </>
  );
};

export default TrialDetail;
